import resumes from 'api/resumes'
import * as types from '../mutation-types'

const Promise = window.Promise || require('promise')

export const saveDraftResume = ({ commit }, data) => {
  commit(types.DRAFT_RESUME, data)
}

export const resumeChecked = ({ commit }, payload = { id: '', force: undefined }) => {
  commit(types.RESUME_CHECKED, payload)
}

export const cloneResume = ({ commit, dispatch, rootState }, payload) => {
  if (rootState.users.token !== '') {
    return resumes.clone(
      rootState.users.token,
      {
        resumeId: payload.id,
        userId: rootState.users.userData.id
      }
    ).then(() => {
      if (typeof payload.params === 'undefined') {
        payload.params = { page: 1 }
      }
      dispatch('resumes/fetchUserResumes', payload.params, { root: true })
    })
  } else {
    return Promise.reject({
      status: 'err',
      messages: 'User token does not exists.'
    })
  }
}

export const switchSelectedResumeStatus = ({ commit, dispatch, rootState }, payload) => {
  if (rootState.users.token !== '') {
    let resumeIds = rootState.resumes.list.items.filter(item => {
      if (payload.status === 'delete') {
        return item.checked === true
      } else {
        return item.checked === true && !(item.opening === (payload.status === 'open'))
      }
    })

    if (typeof resumeIds !== 'undefined') {
      resumeIds = resumeIds.reduce((carry, resume) => {
        return carry.concat([resume.id])
      }, [])
    }
    return resumes.switchSelectedStatus(
      rootState.users.token,
      {
        userId: rootState.users.userData.id,
        resumes: resumeIds
      },
      payload.status
    ).then((data) => {
      if (payload.status === 'delete') {
        if (typeof payload.params === 'undefined') {
          payload.params = { page: 1 }
        }
        dispatch('resumes/fetchUserResumes', payload.params, { root: true })
      } else {
        let list = JSON.parse(JSON.stringify(rootState.resumes.list))
        list.items = list.items.map(item => {
          if (resumeIds.indexOf(item.id) > -1) {
            item.opening = payload.status === 'open'
          }
          return item
        })
        commit(types.RESUMES, list)
      }
      return Promise.resolve(data.results)
    }, (err) => {
      return Promise.reject(err)
    })
  } else {
    return Promise.reject({
      status: 'err',
      messages: 'User token does not exists.'
    })
  }
}

export const switchResumeStatus = ({ commit, dispatch, rootState }, payload) => {
  if (rootState.users.token !== '') {
    return resumes.switchStatus(
      rootState.users.token,
      {
        resumeId: payload.id,
        userId: rootState.users.userData.id
      },
      payload.status
    ).then((data) => {
      if (payload.status === 'deleted') {
        if (typeof payload.params === 'undefined') {
          payload.params = { page: 1 }
        }
        dispatch('resumes/fetchUserResumes', payload.params, { root: true })
      } else {
        let list = JSON.parse(JSON.stringify(rootState.resumes.list))
        list.items = list.items.map(item => {
          if (item.id === payload.id) {
            item.opening = payload.status
          }
          return item
        })
        commit(types.RESUMES, list)
      }
      return Promise.resolve(data.results)
    }, (err) => {
      return Promise.reject(err)
    })
  } else {
    return Promise.reject({
      status: 'err',
      messages: 'User token does not exists.'
    })
  }
}

export const fetchUserResumeById = ({ commit, rootState }, id) => {
  if (rootState.users.token !== '') {
    return resumes.getForUsersById(
      rootState.users.token,
      id
    ).then((data) => {
      commit(types.RESUME, data.results)
      return Promise.resolve(data.results)
    }, (err) => {
      return Promise.reject(err)
    })
  } else {
    return Promise.reject({
      status: 'err',
      messages: 'User token does not exists.'
    })
  }
}

export const fetchUserAllResumes = ({ commit, rootState }) => {
  if (rootState.users.token !== '') {
    return resumes.getForUsers(
      rootState.users.token,
      { getAllResumes: true }
    ).then((data) => {
      commit(types.ALL_RESUMES, data.results)
      return Promise.resolve(data.results)
    }, (err) => {
      commit(types.ALL_RESUMES, [])
      return Promise.reject(err)
    })
  } else {
    return Promise.reject({
      status: 'err',
      messages: 'User token does not exists.'
    })
  }
}

export const fetchUserResumes = ({ commit, rootState }, params = { page: 1 }) => {
  if (rootState.users.token !== '') {
    return resumes.getForUsers(
      rootState.users.token,
      params
    ).then((data) => {
      commit(types.RESUMES, data.results)
      return Promise.resolve(data.results)
    }, (err) => {
      commit(types.RESUMES, [])
      return Promise.reject(err)
    })
  } else {
    return Promise.reject({
      status: 'err',
      messages: 'User token does not exists.'
    })
  }
}

export const updateResume = ({ commit, dispatch, rootState }, data) => {
  if (rootState.users.token !== '') {
    return resumes.update(
      rootState.users.token,
      rootState.users.userData.id,
      data
    ).then(() => {
      if (data.resumeId !== '') {
        dispatch('resumes/fetchUserResumeById', data.resumeId, { root: true })
      }
      return Promise.resolve()
    }, (err) => {
      return Promise.reject(err)
    })
  } else {
    return Promise.reject({
      status: 'err',
      messages: 'User token does not exists.'
    })
  }
}

export const createResume = ({ commit, dispatch, rootState }, data) => {
  if (rootState.users.token !== '') {
    return resumes.add(
      rootState.users.token,
      rootState.users.userData.id,
      data
    ).then(() => {
      if (data.resumeId !== '') {
        dispatch('resumes/fetchUserResumeById', data.resumeId, { root: true })
      }
      return Promise.resolve()
    }, (err) => {
      return Promise.reject(err)
    })
  } else {
    return Promise.reject({
      status: 'err',
      messages: 'User token does not exists.'
    })
  }
}



// WEBPACK FOOTER //
// ./src/vuex/resumes/actions.js